import type { ChatMessageResponseAllOfBasicInfoAllOf } from './chatMessageResponseAllOfBasicInfoAllOf';
import type { ChatMessageResponseAllOfBasicInfoAllOfTwo } from './chatMessageResponseAllOfBasicInfoAllOfTwo';

export type ChatMessageResponseAllOfBasicInfo = ChatMessageResponseAllOfBasicInfoAllOf & ChatMessageResponseAllOfBasicInfoAllOfTwo;
